/**
 * Define App Locals & Configs
 *
 * @author Anas Louter
 */

// Define the type for configuration
interface AppConfig {
    base_api_url: string;
    is_staging: boolean;
    is_production: boolean;
}

class Locals {
    private static configData: AppConfig | null = null;
    /**
     * Makes env configs available for your app
     * throughout the app's runtime
     */
    public static config(): AppConfig {
        if (!Locals.configData) {
            // Use Vite's import.meta.env for browser-compatible environment variables
            const baseApiUrl = import.meta.env.DEV
                ? (import.meta.env.VITE_API_URL ?? 'http://localhost:3000')
                : (import.meta.env.VITE_API_URL ?? '');

            const isStaging = import.meta.env.VITE_STAGING === 'true';
            const isProduction = import.meta.env.PROD && !isStaging;

            Locals.configData = {
                base_api_url: baseApiUrl,
                is_staging: isStaging,
                is_production: isProduction
            };
        }
        return Locals.configData;
    }
}

export default Locals;
